import { useContext, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import compose from 'ramda/src/compose';
import { noSubscriptions } from '../constants/subscription.constant';
import useSearchSubscription from './hooks/useSearchSubscription';
import { ConfigMessageContext } from '../app/configMessageContext';

function SubscriptionCheck(props) {
  const {
    callback,
    faultCallback,
    onFaultChange,
    submitOrderUpdateCountryResponse,
  } = props;
  const TIMEOUT = 1000;
  const MAX_COUNT = Number(ASCENDON_ENV_CONFIG.contentRetryCount);
  const { bypassApigee } = useContext(ConfigMessageContext);
  const [count, setCount] = useState(0);
  const [subscriptionUiModel, subscriptionFault, requestSearchSubscription] =
    useSearchSubscription();

  const [modelToCheck, setModelToCheck] = useState(undefined);

  const isPricingPlanIdFound = (subscriptionUIModal, submitOrderResponse) => {
    const orderPricingPlanId =
      submitOrderResponse?.submitOrderUpdateCountryResult?.Order?.Items?.[0]
        ?.PricingPlan?.Id;
    if (!orderPricingPlanId) {
      return false;
    }
    const isPricingPlanIdMatched = (subscriptionUIModal?.details || []).some(
      (searchSubscription) =>
        searchSubscription?.PricingPlan?.Id === orderPricingPlanId,
    );

    return isPricingPlanIdMatched;
  };

  useEffect(() => {
    if (subscriptionFault && onFaultChange) {
      onFaultChange(subscriptionFault);
    }
  }, [subscriptionFault, onFaultChange]);

  useEffect(() => {
    requestSearchSubscription({ emulateApigeeCall: bypassApigee });
    setCount(count + 1);
  }, []);

  useEffect(() => {
    if (modelToCheck) {
      if (
        modelToCheck !== noSubscriptions &&
        isPricingPlanIdFound(modelToCheck, submitOrderUpdateCountryResponse)
      ) {
        if (callback) {
          callback();
        }
      } else {
        if (count > MAX_COUNT) {
          if (faultCallback) {
            faultCallback();
          }
        } else {
          setTimeout(() => {
            setCount(count + 1);
            setModelToCheck(undefined);
            requestSearchSubscription({ emulateApigeeCall: bypassApigee });
          }, TIMEOUT);
        }
      }
    }
  }, [modelToCheck]);

  useEffect(() => {
    if (subscriptionUiModel) {
      setModelToCheck(subscriptionUiModel);
    }
  }, [subscriptionUiModel]);

  useEffect(() => {
    if (subscriptionFault && faultCallback) {
      faultCallback();
    }
  }, [subscriptionFault]);

  return <></>;
}

export default compose(withTranslation())(SubscriptionCheck);
